import { takeLatest } from 'redux-saga/effects'
import { CREATE_WHITELABEL } from 'app/redux-base/actions/createWL'
import createWL from './createWL'

export default function* watchCreateWL() {
  yield takeLatest(CREATE_WHITELABEL.REQUEST, createWL)
}
